"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jquery_1 = __importDefault(require("jquery"));
var stimulus_1 = require("stimulus");
var SLIDE_SPEED = 500;
var ListToggleableController = /** @class */ (function (_super) {
    __extends(ListToggleableController, _super);
    function ListToggleableController() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.connect = function () {
            if (!_this.hasHideableListTarget || !_this.hasShowButtonTarget || !_this.hasHideButtonTarget) {
                return;
            }
            _this.$hideableList = (0, jquery_1.default)(_this.hideableListTarget);
            _this.$hideButton = (0, jquery_1.default)(_this.hideButtonTarget);
            _this.$showButton = (0, jquery_1.default)(_this.showButtonTarget);
            _this.$hideableList.hide();
            _this.$hideButton.hide();
        };
        _this.show = function () {
            var _a, _b, _c;
            (_a = _this.$showButton) === null || _a === void 0 ? void 0 : _a.hide();
            (_b = _this.$hideableList) === null || _b === void 0 ? void 0 : _b.slideDown(SLIDE_SPEED);
            (_c = _this.$hideButton) === null || _c === void 0 ? void 0 : _c.show();
        };
        _this.hide = function () {
            var _a, _b, _c;
            (_a = _this.$hideableList) === null || _a === void 0 ? void 0 : _a.slideUp(SLIDE_SPEED);
            (_b = _this.$hideButton) === null || _b === void 0 ? void 0 : _b.hide();
            (_c = _this.$showButton) === null || _c === void 0 ? void 0 : _c.show();
        };
        return _this;
    }
    ListToggleableController.targets = ["hideableList", "showButton", "hideButton"];
    return ListToggleableController;
}(stimulus_1.Controller));
exports.default = ListToggleableController;
